// API calls for recording and canceling programs/series
// Each function returns a FormMessagesProps object

import { FormMessagesProps, Recording } from '../types'
import {
  getRecordProgramResponse,
  getCancelProgramResponse,
} from './recording-helper'

export async function recordProgram(
  callLetter: string,
  programId: string,
  startDateUTC: string
) {
  const url = `${
    import.meta.env.VITE_SERVICE_URL
  }/Services/GridTv/GridTv.svc/GetScheduleProgram?callLetter=${callLetter}&programId=${programId}&startDateUTC=${startDateUTC}&userAgent=PC_GTV`

  const res = await fetch(url, {
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  })
  const json = await res.json()
  const recordData = mapRecordingDataFromAPI(json.Result)

  return {
    feedback: getRecordProgramResponse(json.StatusCode, recordData),
    recording: recordData,
  }
}

export async function recordSeries(
  callLetter: string,
  programId: string,
  startDateUtc: string,
  seriesId: string
) {
  const url = `${
    import.meta.env.VITE_SERVICE_URL
  }/Services/GridTv/GridTv.svc/GetScheduleSeries?callLetter=${callLetter}&programId=${programId}&startDateUTC=${startDateUtc}&seriesId=${seriesId}&userAgent=PC_GTV`

  const res = await fetch(url, {
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  })

  const json = await res.json()
  const recordData = mapRecordingDataFromAPI(json.Result)
  return {
    feedback: getRecordProgramResponse(json.StatusCode, recordData),
    recording: recordData,
  }
}

export async function cancelRecording(
  scheduleId: string
): Promise<FormMessagesProps> {
  const url = `${
    import.meta.env.VITE_SERVICE_URL
  }/Services/GridTv/GridTv.svc/DeleteSchedule?scheduleId=${scheduleId}&userAgent=PC_GTV`
  const res = await fetch(url, {
    credentials: 'include',
  })
  const json = await res.json()
  return getCancelProgramResponse(json.StatusCode)
}

export const mapRecordingDataFromAPI = (recordingData: any) => {
  if (!recordingData) {
    return undefined
  }
  const startDate = new Date(recordingData.StartDateUtc)
  return {
    id: recordingData.GuidGravacao || recordingData.Id,
    callLetter: recordingData.CallLetter,
    frequency: recordingData.Frequency.toLowerCase(),
    programId: recordingData.ProgramId,
    scheduledPrograms: recordingData.ScheduledPrograms.map((schedule: any) => {
      const startDateSchedule = new Date(schedule.StartDateUtc)
      const endDateSchedule = new Date(schedule.EndDateUtc)
      return {
        id: schedule.GuidGravacao || schedule.Id,
        programId: schedule.ProgramId,
        title: schedule.Title,
        start: {
          utc: schedule.StartDate,
          date: startDateSchedule,
          day: startDateSchedule.toLocaleDateString('pt-PT', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
          }),
          time: startDateSchedule.toLocaleTimeString('pt-PT', {
            hour: '2-digit',
            minute: '2-digit',
          }),
        },
        end: {
          utc: schedule.EndDate,
          date: endDateSchedule,
          day: endDateSchedule.toLocaleDateString('pt-PT', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
          }),
          time: endDateSchedule.toLocaleTimeString('pt-PT', {
            hour: '2-digit',
            minute: '2-digit',
          }),
        },
        channel: schedule.CallLetter,
        state: schedule.State.toLowerCase(),
      }
    }),
    seriesId: recordingData.SeriesId,
    start: {
      utc: recordingData.StartDateUtc,
      date: startDate,
      day: startDate.toLocaleDateString('pt-PT', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      }),
      time: startDate.toLocaleTimeString('pt-PT', {
        hour: '2-digit',
        minute: '2-digit',
      }),
    },
    title: recordingData.Title,
  } as Recording
}

export const fetchUserRecordings = async () => {
  const response = await fetch(
    `${
      import.meta.env.VITE_SERVICE_URL
    }/Services/GridTv/GridTv.svc/GetSchedules?userAgent=PC_GTV`,
    { credentials: 'include' }
  )
  if (!response.ok) throw new Error('Failed to fetch user recordings')
  const json = await response.json()
  return json.Result.map((item: any) => mapRecordingDataFromAPI(item))
}

export const fetchIsProgramRecording = async (programId: string) => {
  const response = await fetch(
    `${
      import.meta.env.VITE_SERVICE_URL
    }/Services/GridTv/GridTv.svc/GetValidateScheduleState?programId=${programId}`,
    { credentials: 'include' }
  )
  if (!response.ok) throw new Error('Failed to fetch program info')
  const json = await response.json()
  return mapRecordingDataFromAPI(json.Result?.length > 0 ? json.Result[0] : {})
}
